import styled from 'styled-components';

export const IconWrapper = styled.div`
  font-size: 1.5rem;
  margin-bottom: 4px;
`;
